export const GoogleMap = () => {
	return (
		<iframe
			title='Mapa'
			width='100%'
			height='400'
			src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2505.1910516965697!2d16.659679715381882!3d50.72677987952374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470e861c3179fcf5%3A0x41a0839a46bb5b99!2sGarncarska%203%2C%2058-200%20Dzier%C5%BConi%C3%B3w!5e0!3m2!1spl!2spl!4v1661378494169!5m2!1spl!2spl'></iframe>
	)
}
